export const COLORTEXTO = '#2a3547'
export const COLORTEXTOSUAVE = '#5a6a85'